module.exports = __webpack_public_path__ + "static/media/icarros.9ffbfb0b.png";